// extracted by mini-css-extract-plugin
export default {"var-in-desktop":"min-width: 768px","varInDesktop":"min-width: 768px","varSpUp4":"2rem","varSpUp9":"3.25rem","container":"container--2890a"};